export const getDivTemplate = (className?: string) => `<div class="${className || ""}">$injectDivData</div>`;

export const getSpanTemplate = (className?: string) => `<span class="${className || ""}">$injectSpanData</span>`;

export const getLiTemplate = (className?: string) => `<li class="${className || ""}">$injectLiData</li>`;

export const getOlTemplate = (className?: string) => `<ol class="${className || ""}">$injectOlData</ol>`;

export const getUlTemplate = (className?: string) => `<ul class="${className || ""}">$injectUlData</ul>`;

export const getSectionTemplate = (className?: string) => `<section class="${className || ""}">$injectSectionData</section>`;

export const getPdfRowTemplate = (className?: string) => `<div class="pdf-table-row ${className || ""}">$injectRowBody</div>`

export const getPdfColTemplate = (className?: string) => `<div class="pdf-table-col ${className || ""}">$injectColBody</div>`